import { render, staticRenderFns } from "./FacialHair.vue?vue&type=template&id=4c8a78be&scoped=true&"
import script from "./FacialHair.vue?vue&type=script&lang=js&"
export * from "./FacialHair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a78be",
  null
  
)

export default component.exports